module.exports = __webpack_public_path__ + "static/media/fat_icon.18e8beac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fat_icon.svg
// module id = 151
// module chunks = 0